import config from 'Cloud/config';
import RADAR from 'serviceWorker/RADAR';

const { PH_RegisterBackURL } = config.get('PHLinks') || {};

export const getSuccessPage = (location: any) => {
    if (/^((\/subscriptions)|(\/promocodes)|(\/discount)|(\/public))\/?$/.test(location.pathname)) {
        return location.href;
    }

    return `${location.protocol}//${location.hostname}/home/`;
};

export const reloadPage = () => {
    // @ts-ignore
    RADAR.beaconImmediate('auth_change').after(function () {
        const href = getSuccessPage(window.location);

        if (href === window.location.href) {
            window.location.reload();
        } else {
            window.location.href = href;
        }
    });
};

const registerLink = `https://r.mail.ru/cls22587493/r.mail.ru/clb1126011/e.mail.ru/signup?from=navi&lang=ru_RU&back=${PH_RegisterBackURL}`;

export const goToRegisterPage = () => {
    window.open(registerLink, '_blank');
};
